import MobileCustomPage from './mobile-custom-page'

export { MobileCustomPage }
